import { render, staticRenderFns } from "./ContabilidadScreenReportes.vue?vue&type=template&id=39068768&scoped=true"
import script from "./ContabilidadScreenReportes.vue?vue&type=script&lang=js"
export * from "./ContabilidadScreenReportes.vue?vue&type=script&lang=js"
import style0 from "./ContabilidadScreenReportes.vue?vue&type=style&index=0&id=39068768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39068768",
  null
  
)

export default component.exports